
import { Handler, HasOnError, HasOnSuccess, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Data/Products/Handlers/LoadProductByPath";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import { GetProductByPathApiV2Parameter } from "@insite/client-framework/Services/ProductServiceV2";

type Parameter = {
    path: string;
    addToRecentlyViewed?: boolean;
} & HasOnSuccess<ProductModel> &
    HasOnError<string>;
type Props = {
    apiParameter: GetProductByPathApiV2Parameter;
    apiResult: ProductModel;
};

type HandlerType = Handler<Parameter, Props>;

export const PopulateApiParameterWithProperties: HandlerType = props => {
    props.apiParameter = {
        ...props.parameter,
        expand: ["detail", "specifications", "content", "images", "documents", "attributes", "variantTraits", "badges", "properties"],
        includeAttributes: ["includeOnProduct", "notFromCategory"],
    };
};

replaceInChain(chain, PopulateApiParameter, PopulateApiParameterWithProperties);